import {
  Calendar,
  Callout,
  DefaultButton,
  defaultCalendarStrings,
  DirectionalHint,
  Dropdown,
  FocusTrapZone,
  Icon,
  Stack,
} from "@fluentui/react";
import React from "react";
import CustomFilterTable from "../FilterTable/CustomFilterTable";
import { useBoolean } from "@fluentui/react-hooks";

const filterDropdownOptions = [
  { key: "managers", text: "Managers" },
  { key: "teammates", text: "Teammates" },
  { key: "teamleads", text: "Team Leads" },
  { key: "developers", text: "Developers" },
];

const dropdownStyles = {
  dropdown: { width: 200 },
};

function TimeSheet({ data, selectedTaskIndex }) {
  const [showCalendar, { toggle: toggleShowCalendar, setFalse: hideCalendar }] =
    useBoolean(false);
  const [selectedDate, setSelectedDate] = React.useState();
  const [toggle, setToggle] = React.useState(false);
  const buttonContainerRef = React.useRef(null);

  const onSelectDate = React.useCallback(
    (date) => {
      setSelectedDate(date);
      hideCalendar();
    },
    [hideCalendar]
  );

  return (
    <>
      <div className="ms-fontSize-14 margin-left task-details-container">
        <strong>Task Id: </strong> {data[selectedTaskIndex].id}
        <br />
        <strong>Task Name: </strong> {data[selectedTaskIndex].TaskName}
        <br />
      </div>
      <div className="time-sheet-wrapper">
        <div className="ms-Grid">
          <div
            className="ms-Grid-row ms-sm12"
            style={{ padding: "40px 14px 20px" }}
          >
            <span className="ms-Grid-col ms-sm4 ms-smPush8">
              07 - 13 Aug 2017
            </span>
            <span style={{ float: "right", display: "inline-flex" }}>
              <Stack tokens={{ childrenGap: 8 }} horizontal>
                <Stack horizontal tokens={{ childrenGap: 0 }}>
                  <button className="arrow-btn">&lt;</button>
                  <DefaultButton text="This Week" allowDisabledFocus />
                  <button className="arrow-btn">&gt;</button>
                </Stack>
                <div ref={buttonContainerRef}>
                  <DefaultButton onClick={toggleShowCalendar}>
                    <Icon iconName="Calendar" />
                  </DefaultButton>
                </div>
                <div>
                  <Stack horizontal tokens={{ childrenGap: 1 }}>
                    <DefaultButton
                      text="Day"
                      onClick={() => setToggle(!toggle)}
                      allowDisabledFocus
                      checked={toggle}
                    />
                    <DefaultButton
                      text="Week"
                      onClick={() => setToggle(!toggle)}
                      allowDisabledFocus
                      checked={!toggle}
                    />
                  </Stack>
                </div>

                <Dropdown
                  defaultSelectedKey="teammates"
                  options={filterDropdownOptions}
                  disabled={false}
                  styles={dropdownStyles}
                />
              </Stack>
            </span>
          </div>
          <div className="ms-Grid-row">
            <CustomFilterTable />
          </div>
        </div>
        {showCalendar && (
          <Callout
            isBeakVisible={false}
            gapSpace={0}
            doNotLayer={false}
            target={buttonContainerRef}
            directionalHint={DirectionalHint.bottomLeftEdge}
            onDismiss={hideCalendar}
            setInitialFocus
          >
            <FocusTrapZone isClickableOutsideFocusTrap>
              <Calendar
                onSelectDate={onSelectDate}
                onDismiss={hideCalendar}
                isMonthPickerVisible
                value={selectedDate}
                highlightCurrentMonth
                isDayPickerVisible
                showGoToToday
                strings={defaultCalendarStrings}
              />
            </FocusTrapZone>
          </Callout>
        )}
      </div>
    </>
  );
}

export default TimeSheet;
